<template>
  <v-card class="mb-5">
    <v-card-title class="card-title">Dependientes directos</v-card-title>
    <v-card-text class="pa-6">
      <div class="d-flex mb-4">
        <v-spacer></v-spacer>
        <v-btn v-if="create_access" outlined color="primary" @click="$emit('addChild')"><v-icon small left>add</v-icon>Agregar dependiente</v-btn>
      </div>

      <v-simple-table>
        <thead>
          <tr>
            <th style="width: 90px">Orden</th>
            <th>Puesto</th>
            <th>Responsable</th>
            <th>Estado</th>
            <th class="text-center" style="width: 140px">Acción</th>
          </tr>
        </thead>
        <draggable v-model="rows" tag="tbody" handle=".oc-drag-handle" :disabled="!update_access || saving_order" @end="saveOrder">
          <tr v-for="(child, index) in rows" :key="child.id">
            <td>
              <v-icon v-if="update_access" small class="oc-drag-handle mr-2" style="cursor: grab" title="Arrastrar para reordenar">drag_indicator</v-icon>
              {{ index + 1 }}
            </td>
            <td>{{ child.name }}</td>
            <td>
              <span v-if="child.legajo">{{ child.legajo.name }} {{ child.legajo.surname }}</span>
              <span v-else class="font-italic grey--text text--darken-1">Sin asignar</span>
            </td>
            <td>
              <v-chip v-if="!child.enabled" small class="oc-status-chip" color="grey lighten-3" text-color="grey darken-2">Inactivo</v-chip>
              <v-chip v-else-if="child.legajo == null" small class="oc-status-chip" color="orange lighten-4" text-color="orange darken-4">Vacante</v-chip>
              <v-chip v-else small class="oc-status-chip" color="green lighten-4" text-color="green darken-3">Activo</v-chip>
            </td>
            <td class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="blue" class="mr-2" @click="$emit('editChild', child)">edit</v-icon>
                </template>
                <span>{{ update_access ? "Editar" : "Ver" }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-if="update_access" v-on="on" small color="orange" class="mr-2" @click="$emit('assignResponsible', child)">person_outline</v-icon>
                </template>
                <span>Asignar responsable</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-if="delete_access" v-on="on" small color="red" @click="$emit('deleteChild', child)">delete_outline</v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </tr>
          <tr v-if="rows.length == 0">
            <td colspan="5" class="text-center grey--text">El puesto no tiene dependientes.</td>
          </tr>
        </draggable>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
import { orgChartService } from "@/libs/ws/orgChartService";

export default {
  name: "CardDependents",
  components: { draggable },
  props: {
    parent_id: Number,
    children: { type: Array, default: () => [] },
    create_access: Boolean,
    update_access: Boolean,
    delete_access: Boolean,
  },
  data() {
    return {
      rows: [],
      saving_order: false,
    };
  },
  watch: {
    children: {
      immediate: true,
      handler(value) {
        this.rows = [...value];
      },
    },
  },
  methods: {
    saveOrder(e) {
      if (e.oldIndex == e.newIndex) return;
      this.saving_order = true;
      orgChartService
        .reorder({ parent_id: this.parent_id, ids: this.rows.map((row) => row.id) })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.$emit("reordered");
          } else {
            this.$toast.error(response.msg, "Error");
            this.rows = [...this.children];
          }
        })
        .catch((e) => {
          console.log(e);
          this.rows = [...this.children];
        })
        .finally(() => (this.saving_order = false));
    },
  },
};
</script>
